import util from '@bmp-vue/core/api/util'
const controller = 'Gloriabeauty'
const ctrl = Object.assign({}, util.GetCrud(controller, ['none']), {
  Get () {
    return [
      { modelo: 0, prazoInicio: 1, prazoFim: 23, taxa: 1.81 },
      { modelo: 0, prazoInicio: 24, prazoFim: 35, taxa: 1.54 },
      { modelo: 0, prazoInicio: 36, prazoFim: 47, taxa: 1.52 },
      { modelo: 0, prazoInicio: 48, prazoFim: 60, taxa: 1.46 },
      { modelo: 1, prazoInicio: 1, prazoFim: 23, taxa: 2.03 },
      { modelo: 1, prazoInicio: 24, prazoFim: 35, taxa: 1.68 },
      { modelo: 1, prazoInicio: 36, prazoFim: 47, taxa: 1.62 },
      { modelo: 1, prazoInicio: 48, prazoFim: 60, taxa: 1.62 },
      { modelo: 2, prazoInicio: 1, prazoFim: 23, taxa: 2.24 },
      { modelo: 2, prazoInicio: 24, prazoFim: 35, taxa: 1.79 },
      { modelo: 2, prazoInicio: 35, prazoFim: 47, taxa: 1.70 },
      { modelo: 2, prazoInicio: 48, prazoFim: 60, taxa: 1.67 },
      { modelo: 3, prazoInicio: 1, prazoFim: 23, taxa: 2.30 },
      { modelo: 3, prazoInicio: 24, prazoFim: 35, taxa: 1.86 },
      { modelo: 3, prazoInicio: 36, prazoFim: 47, taxa: 1.77 },
      { modelo: 3, prazoInicio: 48, prazoFim: 60, taxa: 1.71 }
    ]
  },
  GetItem (modelo, prazo) {
    return ctrl.Get().find(item => item.modelo === modelo && item.prazoInicio <= prazo && item.prazoFim >= prazo)
  },
  ChangeVlrProdutoBem (th, value) {
    let vlrEntrada = 0
    if (value) {
      value = th.$api.UI.Parse.Decimal(value)
      vlrEntrada = parseFloat((value * th.$param.VlrMinEntrada).toFixed(2))
    }
    th.$set(th.model, 'VlrEntrada', vlrEntrada)
  },
  SavePropostaCampoAuxiliar (th) {
    const campos = []

    if ([null, undefined].indexOf(th.model.ObservacaoVendedor) < 0) { campos.push({ CodigoProposta: th.model.Codigo, NomeCampo: 'PROPOSTA_OBSERVACAOVENDEDOR', ValorCampo: th.model.ObservacaoVendedor }) }

    if (campos.length > 0) { th.$api.Multiplo.SavePropostaCampoAuxiliar({ dto: campos }) }
  },
  ImportaAssinante (th, request, importEmitente) {
    if (importEmitente) {
      th.$api.Multiplo.InsertCCBDigitalAssinatura(request).then(function (response) {
        th.$api.UI.PostAction(response, 'Importação realizada com sucesso!')
      })
    }
  },
  CarregaDiasAcrescimo (th, value) {
    const date = th.$api.UI.Date.AddDay(new Date(), value)
    th.model.nroDiasAcrescimoPrimPagto = th.$api.UI.Date.DaysBetween(th.$api.UI.Date.AddMonth(new Date(), 1), date)
  },
})

export default ctrl
